import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import { addRating } from '../../../store/actions/ratingActions';

const styles = theme => ({
  layout: {
    width: 'auto',
    background: '#f5f6fa',
    paddingTop: theme.spacing.unit * 7,
    paddingBottom: theme.spacing.unit * 10,
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    [theme.breakpoints.up(600 + theme.spacing.unit * 4 * 2)]: {
      width: '100%',
      boxSizing: 'border-box'
    }
  },
  root: {
    width: '98%',
    padding: '30px',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '40px',
    minHeight: '550px'
  },
  pageTitle: {
    marginBottom: '20px',
    cursor: 'pointer'
  },
  backButton: {
    marginBottom: '4px',
    marginRight: '10px'
  },
  offerTerms: {
    maxWidth: '300px'
  },
  radioGroup: {
    paddingLeft: '75px'
  },
  details: {
    textAlign: 'center',
    margin: '10px 0',
    width: '100%',
    minHeight: 57,
    textAlign: 'left'
  },
  submitButton: {
    float: 'right'
  },
  chip: {
    marginLeft: '3px',
    marginRight: '3px'
  },
  userPanel: {
    width: '350px'
  },
  youtubeVideoUpload: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: '30px',
    height: '0',
    overflow: 'hidden',
    '& iframe': {
      width: '100%',
      height: '100%'
    },
    marginTop: '30px',
    marginBottom: '10px'
  },
  iframeContainer: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '90%',
    height: '90%'
  },
  ratingContainer: {
    height: '75px',
    backgroundColor: '#22c26e',
    marginTop: '-30px',
    marginRight: '-30px',
    marginLeft: '-30px',
    boxShadow: '0 0 5px 2px gray',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
    flexDirection: 'column',
    marginBottom: '30px'
  },
  ratingText: {
    color: 'white'
  },
  deal: {
    width: 200,
    textAlign: 'center',
    margin: '10px 0'
  },
  statsContainer: {
    textAlign: 'center'
  },
  statsContainerBottom: {
    textAlign: 'center',
    marginTop: '15px'
  },
  dealDetails: {
    marginTop: '30px'
  },
  circleImage: {
    objectFit: 'cover',
    borderRadius: '50%',
    width: '200px',
    height: '200px'
  }
});

const mapDispatchToProps = dispatch => {
  return {
    addRatingHandler: (dealId, rater, ratedUser, rating) =>
      dispatch(addRating(dealId, rater, ratedUser, rating))
  };
};

export default compose(
  withStyles(styles),
  withRouter,
  withFirestore,
  connect(
    null,
    mapDispatchToProps
  )
);



// WEBPACK FOOTER //
// ./src/components/deals/view-deal/ViewDeal.enhancer.js